(function () {
  'use strict';

  var cache = new Map();
  var cacheLifetime = 60000;

  function sameOriginUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch (error) {
      return null;
    }
  }

  function imageUrl(product) {
    var image = product.featured_image || product.image;
    var source = typeof image === 'string' ? image : image && (image.url || image.src);
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (url.origin !== window.location.origin && !(url.protocol === 'https:' && url.hostname === 'cdn.shopify.com')) return '';
      url.searchParams.set('width', '96');
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function init(form) {
    if (form.dataset.suggestReady === 'true') return;
    var input = form.querySelector('input[name="q"]');
    var panel = form.querySelector('[data-header-suggest]');
    var list = form.querySelector('[data-suggest-list]');
    var status = form.querySelector('[data-suggest-status]');
    var viewAll = form.querySelector('[data-suggest-all]');
    var catalogUrl = sameOriginUrl(form.action);
    var endpoint = sameOriginUrl(form.dataset.suggestUrl);
    if (!input || !panel || !list || !status || !viewAll || !catalogUrl || !endpoint) return;
    form.dataset.suggestReady = 'true';

    var timer;
    var controller;
    var sequence = 0;
    var active = -1;
    var composing = false;
    var catalogPath = catalogUrl.pathname.replace(/\/$/, '');
    var currentPath = window.location.pathname.replace(/\/$/, '');
    var isCatalog = currentPath === catalogPath || currentPath.indexOf(catalogPath + '/') === 0;

    function resultUrl(query) {
      var url = new URL(catalogUrl.href);
      url.search = '';
      url.hash = '';
      var currentParams = new URLSearchParams(window.location.search);
      ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
        if (currentParams.has(key)) url.searchParams.set(key, currentParams.get(key));
      });
      if (query.trim()) url.searchParams.set('q', query.trim());
      return url.pathname + url.search;
    }

    function resetActive() {
      active = -1;
      input.removeAttribute('aria-activedescendant');
      list.querySelectorAll('[role="option"]').forEach(function (option) {
        option.setAttribute('aria-selected', 'false');
      });
    }

    function cancel() {
      window.clearTimeout(timer);
      sequence += 1;
      if (controller) controller.abort();
      controller = null;
      list.setAttribute('aria-busy', 'false');
    }

    function close() {
      cancel();
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      resetActive();
    }

    function open(query) {
      viewAll.href = resultUrl(query);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function publishQuery() {
      if (isCatalog) {
        document.dispatchEvent(new CustomEvent('hevisynx:catalog-query', {
          detail: { query: input.value, source: 'header' }
        }));
      }
    }

    function chooseCatalog(event, query) {
      if (!isCatalog || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      input.value = query;
      publishQuery();
      input.focus();
      close();
    }

    function render(products, query) {
      resetActive();
      list.replaceChildren();
      products.slice(0, 6).forEach(function (product, index) {
        if (!product || typeof product.title !== 'string' || !product.title.trim()) return;
        var item = document.createElement('li');
        item.setAttribute('role', 'presentation');
        var option = document.createElement('a');
        option.id = list.id + '-' + index;
        option.className = 'hx-header-suggest__option';
        option.href = resultUrl(product.title);
        option.addEventListener('click', function (event) { chooseCatalog(event, product.title); });
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.tabIndex = -1;

        var source = imageUrl(product);
        if (source) {
          var image = document.createElement('img');
          image.className = 'hx-header-suggest__image';
          image.src = source;
          image.alt = '';
          image.width = 48;
          image.height = 48;
          image.loading = 'lazy';
          image.addEventListener('error', function () { this.hidden = true; }, { once: true });
          option.appendChild(image);
        }

        var copy = document.createElement('span');
        copy.className = 'hx-header-suggest__copy';
        var title = document.createElement('span');
        title.className = 'hx-header-suggest__title';
        title.textContent = product.title;
        copy.appendChild(title);
        var sku = product.sku;
        if (!sku && Array.isArray(product.variants)) {
          var variant = product.variants.find(function (entry) { return entry && entry.sku; });
          if (variant) sku = variant.sku;
        }
        if (typeof sku === 'string' && sku.trim()) {
          var reference = document.createElement('span');
          reference.className = 'hx-header-suggest__sku';
          reference.textContent = 'SKU: ' + sku;
          copy.appendChild(reference);
        }
        option.appendChild(copy);
        item.appendChild(option);
        list.appendChild(item);
      });
      status.textContent = list.children.length ? (form.dataset.resultsLabel || 'Catalog') + ' · ' + list.children.length : 'No suggestions. Search Catalog for results.';
      open(query);
    }

    function suggest(query, requestId) {
      var cached = cache.get(endpoint.pathname + ':' + query.toLowerCase());
      if (cached && Date.now() - cached.time < cacheLifetime) {
        render(cached.products, query);
        list.setAttribute('aria-busy', 'false');
        return;
      }
      controller = new AbortController();
      var url = new URL(endpoint.href);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][fields]', 'title,variants.title,variants.sku');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      list.setAttribute('aria-busy', 'true');
      fetch(url.pathname + url.search, { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Suggestions unavailable');
          return response.json();
        })
        .then(function (data) {
          if (requestId !== sequence || input.value.trim() !== query || !form.isConnected) return;
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          if (!Array.isArray(products)) throw new Error('Invalid suggestions');
          if (cache.size >= 30) cache.delete(cache.keys().next().value);
          cache.set(endpoint.pathname + ':' + query.toLowerCase(), { time: Date.now(), products: products });
          render(products, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError' || requestId !== sequence || !form.isConnected) return;
          status.textContent = 'Suggestions unavailable. Search Catalog for results.';
          open(query);
        })
        .finally(function () {
          if (requestId !== sequence) return;
          controller = null;
          list.setAttribute('aria-busy', 'false');
        });
    }

    function resolveAndSuggest(query, requestId) {
      var references = window.hevisynxReferenceSearch;
      if (!references || typeof references.resolve !== 'function') {
        suggest(query, requestId);
        return;
      }
      list.setAttribute('aria-busy', 'true');
      Promise.resolve().then(function () { return references.resolve(query); })
        .then(function (result) {
          if (requestId !== sequence || input.value.trim() !== query || !form.isConnected) return;
          if (result && Array.isArray(result.products) && result.products.length) {
            render(result.products, query);
            list.setAttribute('aria-busy', 'false');
          } else {
            suggest(query, requestId);
          }
        }).catch(function () {
          if (requestId === sequence && input.value.trim() === query && form.isConnected) suggest(query, requestId);
        });
    }

    function schedule() {
      cancel();
      resetActive();
      list.replaceChildren();
      var query = input.value.trim();
      if (!query) {
        close();
        return;
      }
      status.textContent = form.dataset.loading || 'Loading...';
      open(query);
      var requestId = sequence;
      timer = window.setTimeout(function () { resolveAndSuggest(query, requestId); }, 250);
    }

    function changed() {
      if (composing) return;
      publishQuery();
      schedule();
    }

    input.addEventListener('input', changed);
    input.addEventListener('compositionstart', function () { composing = true; close(); });
    input.addEventListener('compositionend', function () { composing = false; changed(); });
    input.addEventListener('focus', function () { if (input.value.trim()) schedule(); });
    input.addEventListener('keydown', function (event) {
      if (event.isComposing || composing) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      var options = list.querySelectorAll('[role="option"]');
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (panel.hidden) { schedule(); return; }
        if (!options.length) return;
        var next = active + (event.key === 'ArrowDown' ? 1 : -1);
        if (active < 0) next = event.key === 'ArrowDown' ? 0 : options.length - 1;
        resetActive();
        active = (next + options.length) % options.length;
        options[active].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && !panel.hidden && active >= 0 && options[active]) {
        event.preventDefault();
        options[active].click();
      }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (isCatalog) publishQuery();
      else window.location.assign(resultUrl(input.value));
      close();
    });
    viewAll.addEventListener('click', function (event) { chooseCatalog(event, input.value); });
    form.addEventListener('focusout', function () {
      window.setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0);
    });
    document.addEventListener('pointerdown', function (event) { if (!form.contains(event.target)) close(); });
    document.addEventListener('hevisynx:catalog-query-sync', function (event) {
      if (!event.detail || typeof event.detail.query !== 'string' || input.value === event.detail.query) return;
      input.value = event.detail.query;
      close();
    });
    window.addEventListener('pagehide', close);
    if (isCatalog) input.value = new URLSearchParams(window.location.search).get('q') || '';
    if (window.location.hash === '#' + input.id) input.focus();
  }

  function initAll() {
    document.querySelectorAll('[data-hevisynx-header-search]').forEach(init);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
